import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@material-ui/core';
import { useFormik } from 'formik';
import { useTranslations } from 'utils/useTranslations';
import { useParams } from 'react-router-dom';
import useCaseFetch from 'api/Case';
import * as yup from 'yup';
import { floatWithTwoDigits } from 'utils/floatWithTwoDigits';

interface Props {
  open: boolean;
  onClose: () => void;
}
interface ParamType {
  caseId: string;
}

interface INewCaseForm {
  amount: number;
  paymentNumber: string;
}

const initValues: INewCaseForm = {
  amount: null,
  paymentNumber: '',
};

export const AddPaymentModal = ({ open, onClose }: Props) => {
  const { addPayment } = useCaseFetch();
  const { caseId } = useParams<ParamType>();
  const [loading, setLoading] = useState(false);
  const { values, handleSubmit, handleChange, touched, errors } = useFormik({
    initialValues: initValues,
    async onSubmit(formValues, formContext) {
      try {
        setLoading(true);
        await addPayment({ ...formValues, caseId });
        formContext.resetForm();
        onClose();
        setLoading(false);
      } catch (err) {
        setLoading(false);
      }
    },
    validationSchema: yup.object().shape({
      amount: yup
        .number()
        // eslint-disable-next-line
        .test('float with 2 points', 'Amount must be in propriate format', function () {
          // eslint-disable-next-line
          return floatWithTwoDigits(this.parent.amount);
        })
        .required(),
      paymentNumber: yup.number().positive(),
    }),
  });
  const intl = useTranslations();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{intl('patient.addNewPayment')}</DialogTitle>

      <DialogContent>
        <TextField
          fullWidth
          name="amount"
          type="number"
          value={values.amount}
          error={Boolean(touched.amount && errors.amount)}
          onChange={handleChange}
          label={intl('patient.amount')}
        />
        <TextField
          fullWidth
          name="paymentNumber"
          value={values.paymentNumber}
          error={Boolean(touched.paymentNumber && errors.paymentNumber)}
          onChange={handleChange}
          label={intl('patient.accountNumber')}
        />
      </DialogContent>
      <DialogActions>
        <Button disabled={loading} onClick={onClose} color="secondary">
          {intl('shared.cancel')}
        </Button>
        <Button disabled={loading} color="primary" onClick={() => handleSubmit()}>
          {intl('shared.add')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
